var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen-feedback-container"},[_c('base-feedback-screen',{attrs:{"transparent":_vm.transparent}},[_c('pulse-loader'),(_vm.text)?_c('p',{staticClass:"t1 -mx_0 -mt_1 -mb_0"},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }